import {
  boldFont,
  getRelativeFontSize,
  primaryBlueColor,
  primaryLightGray,
  PrimaryLightTextColor,
  primaryRedColor,
  PrimaryTextColor,
  regularFont,
  theme,
} from "../../../../../utils/styles";

const LeadPersonalDetailsStyles = {


  headerPart: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingBottom: "10px",
    borderBottom: "1px solid rgba(241, 241, 241, 1)",
    marginTop:"-25px"
  },
  mainHeading: {
    fontSize: getRelativeFontSize(4),
    ...boldFont,
    color: PrimaryTextColor,
    marginLeft:"20px"
  },
  periousNext: {
    display: "flex",
    gap: 2, 
  },
  periousNextstyle :{
    width: "auto",
    minWidth:"100px",
    borderColor: "#e7e7e7",
    borderRadius:"8px"
  },

  profilePart:{
    display:"flex",
    width: "100%",
    height:" calc(100vh - 52px)",
  },

  leftSection:{
      borderRight:"1px solid rgba(241, 241, 241, 1)",
      
      width: "350px",
    },
    cardProfile:{
        background:"#3D48E5",
        padding:"15px 20px",
        // borderTopLeftRadius: "5px",
      },
      profileNameBg:{
        background:"#fff",
        width:"40px",
        height:"40px",
        padding:"12px",
        borderRadius:"50%",
        color:"rgba(0, 117, 255, 1)",
        fontSize: getRelativeFontSize(2),
        ...boldFont,
        display:"flex",
        alignItems:"center",
        justifyContent:"center"
      },
    profileNamePart:{
        width:"100%",
        display:"flex",
        alignItems:"center",
        gap:"20px",
        // justifyContent:"space-between",
      },
      profileNamenew:{
        fontSize: getRelativeFontSize(4),
        ...boldFont,
        color:"#fff",
        whiteSpace: "nowrap", 
      overflow: "hidden",  
      textOverflow: "ellipsis", 
      display: "inline-block",  
      },
      emailUid : {
        backgroundColor: "rgba(255, 255, 255, 0.2)", 
        fontSize : getRelativeFontSize(0),
        ...boldFont,
        color :"#fff",
      padding: "5px 15px", 
      borderRadius: "5px", 
      width: "100px",
      height: "30px",
      textAlign: "center", 
      display: "inline-block", 
      },
      iconLayout: {
        display: "flex",
        gap: "10px",
        padding: "10px 0",
        "& .MuiSvgIcon-root": {
          fontSize: getRelativeFontSize(5),
          color: "#fff",    // Icon color
        },
      },
      leadDetails:{
        fontSize: getRelativeFontSize(2),
        backgroundColor: "#ECEDFC", 
        padding: "10px 20px", 
        color:"#3D48E5",
      },
      nameLeadDetailSide : {
        fontSize: getRelativeFontSize(0),
        ...boldFont,
     
      },
      headingFontSize:{
        fontSize: getRelativeFontSize(4),
        ...boldFont,
      },
      paraNameLeadDetailSide:{
        fontSize: getRelativeFontSize(0),
        ...regularFont,
        color:"rgba(88, 89, 108, 1)",
        whiteSpace: "wrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      },
      tabSection:{
        flex: 1,
        // width:"auto",
        "& .MuiTab-root":{
          fontSize:"14px",
          fontWeight:"700",
          textTransform:"capitalize"
        }
      },
      tabContent2:{
        // borderTop:"1px solid rgba(241, 241, 241, 1)",
        padding:"0px 20px",
        height:"calc(100vh - 110px)",
        overflow:"auto",
        scrollbarWidth:"thin"
      },
      taskButton :{
        display:"flex",
         justifyContent:"flex-end",
         
        },
        label: {
            ...regularFont,
            fontSize: getRelativeFontSize(),
            wordSpacing: "2px",
            color: PrimaryTextColor,
          },

          autocomplateStyle: {
            width: "100%",
            background: "#fffff",
            height:"38px",
            textOverflow: "ellipsis", 
            whiteSpace: "nowrap",
            "& .MuiInputBase-input": {
              maxHeight:"38px",
              color: PrimaryTextColor,
              ...regularFont,
              textOverflow: "ellipsis", 
              whiteSpace: "nowrap",
              fontSize: getRelativeFontSize(2),
              "&::placeholder": {
                ...regularFont,
                fontSize: getRelativeFontSize(-1),
                color: PrimaryLightTextColor,
              },
            },
            "&  .MuiOutlinedInput-root": {
              padding: "0px 9px",
            },
            "& .MuiOutlinedInput-root": {
              borderRadius: "4px",
              "&.Mui-focused fieldset": {
                borderColor: "#E7E7EA",
              },
              "&:hover fieldset": {
                borderColor: "#E7E7EA",
              },
            },
            "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
              borderColor: "#E7E7EA",
            },
            "& .MuiAutocomplete-inputRoot":{
              flexWrap:"nowrap"
            }
          },




     
          
          autoInputBlank: {
            "& .MuiFormHelperText-root.Mui-error": {
              color: "#d32f2f",
              fontSize: getRelativeFontSize(),
              ...regularFont,
              marginLeft: "5px",
              marginBottom: "5px",
            },
            "& .MuiAutocomplete-input": {
              fontSize: getRelativeFontSize(),
            },
          },
        
          autoInputFill: {
            "& .MuiFormHelperText-root.Mui-error": {
              color: "#d32f2f",
              fontSize: getRelativeFontSize(),
              ...regularFont,
              marginLeft: "5px",
              marginBottom: "5px",
            },
            "& .MuiAutocomplete-inputFocused": {
              fontSize: getRelativeFontSize(2),
            },
          },
          HeadingForm: {
            fontFamily: "Inter_Bold",
          fontWeight: 700,
          paddingTop:'10px',
          },

          Heading: {
            ...boldFont,
            fontSize: getRelativeFontSize(10),
          },
          custombuttonStyle: {
            width: "200px",
          },
          taskSection:{
            display:"flex",
             alignItems :"center",
              gap :1
          },
          headerName: {
            ...boldFont,
            color: PrimaryTextColor,
            fontSize: getRelativeFontSize(-2),
            textTransform: "capitalize",
          },
          subHeaderName: {
            ...regularFont,
            color: PrimaryTextColor,
            fontSize: getRelativeFontSize(-3),
            textTransform: "capitalize",
            display:"flex",
          },
          rightSection:{
            borderLeft:"1px solid rgba(241, 241, 241, 1)",
            // height:" calc(100vh - 48px)",
            width: "300px",
          },

          sideBoxWrapper:{
            padding: "20px",
            height: "90vh",
            width: "100%",
            backgroundColor: "rgb(255 255 255)",
            overflow : "auto",
            '&::-webkit-scrollbar': {
            display: "none",
            width:"0px"
        
            },
           
        },
        
      
  singleRow: {
    display: "flex",
    // gap: "20px",
    // justifyContent: "space-between"
  },
    spacing:{
padding:"20px"
    },
    centerItems:{
display:"flex",
alignItens:"center",
justifyContent:"center" 
},
profileTable:{
  height: "calc(100vh - 48px)"
},
textField: {
  border: "none",
  width: "100%",
  // "& .MuiFormControl-root-MuiTextField-root .MuiInputBase-input":{
  //   height: "46px",

  // },
  "& .MuiInputBase-input": {
    color: PrimaryTextColor,
    ...regularFont,
    position: "relative",
    background: "#fff",
    height: "38px",
    padding: "0 10px",
    border: "none",
    fontSize: getRelativeFontSize(0),
   
    "&::placeholder": {
      ...regularFont,
      fontSize: getRelativeFontSize(0),
      color: PrimaryLightTextColor,
    },
  },
  "& .MuiOutlinedInput-root": {
    borderRadius: "4px",
    
    "&.Mui-focused fieldset": {
      borderColor: "#E7E7EA",
    },
    "&:hover fieldset": {
      borderColor: "#E7E7EA",
    },
  },
  // "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
  //   borderColor: "#E7E7EA",
  // },
  "& .MuiFormHelperText-root": {
    color: primaryRedColor,
    fontSize: getRelativeFontSize(-1),
    ...regularFont,
    marginLeft: "5px",
    marginBottom: "5px",
  },
  "& input[type='file']": {
    diaplay: "flex",
    alignItems: "center",
    padding: "5px 10px",
    height: "28px",
    fontSize: getRelativeFontSize(0),
    ...regularFont,
  },
},

dateField: {
  height: '38px',
  width: '100%',
  
  '& .MuiInputBase-root': {
    height: '38px',
    overflow: "hidden"
  },
  '& .MuiSvgIcon-root':{
    height:"18px"
  },
  '& .MuiInputBase-input':{
    fontSize:"14px",
  }
},
buttonFooter:{
  // position:"sticky",
  // bottom:"0",
  display:"flex",
  justifyContent:"space-between",
  padding:"10px 15px"
},
  textArea: {
  border: "none",

    // "& .MuiOutlinedInput-root": {
    //   minHeight:"100px",
    //   height: "auto",
    //   display: "flex",
    //   alignItems: "start",
    //   padding: "10px 10px",
    //   fontSize: "15px",
    //   "&.Mui-focused fieldset": {
    //     borderColor: "#E7E7EA",
    //   },
    //   "&:hover fieldset": {
    //     borderColor: "#E7E7EA",
    //   },
    //   "&:hover": {
    //     borderColor: "none", // Removes hover effect
    //   },
    // },
     "& .MuiOutlinedInput-root": {
      minHeight:"100px",
    borderRadius: "4px",
    display: "flex",
    alignItems: "start",
    padding: "10px 10px",
      "& fieldset": {
        borderColor: "#E7E7EA !important", // Force border color in all states
      },
    "&.Mui-focused fieldset": {
      borderColor: "#E7E7EA",
    },
    "&:hover fieldset": {
      borderColor: "#E7E7EA",
    },
  },
  },
  timeline:{
"& .MuiTimeline-root":{
  padding:"0px !important"
}
  }
};

export default LeadPersonalDetailsStyles;
